export default __webpack_public_path__ + "static/Poppins-BoldItalic-cfb635a5111b545f5598482a64d2a2c3.ttf";